import { type SelectProps } from 'antd';
import { useMemo } from 'react';
import { useGetModuleOptionsQuery } from '../../api/queries/getModuleOptions';
import type { ModuleType } from '../../api/types';
import FormFields from '../../themes/admin/Fields/FormFields';
import { useCompany } from '../contexts/CompanyContextManager';
import type { SelectFieldProps } from './SelectField';

const filterOption: SelectProps['filterOption'] = (inputValue, option) =>
    option.label.toString().toLowerCase().includes(inputValue.toLowerCase());

export type UserModuleSelectFieldProps = Omit<SelectFieldProps, 'children' | 'options'> & {
    moduleType: ModuleType;
    companyId?: string;
};

const UserModuleSelectField = ({ moduleType, companyId, ...props }: UserModuleSelectFieldProps) => {
    const company = useCompany(true);
    const companyIdToUse = companyId || company?.id;

    const { data, loading } = useGetModuleOptionsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { kind: moduleType, companyId: companyIdToUse },
    });

    const options = useMemo(
        () =>
            (data?.modules || []).map(module => ({
                value: module.id,
                label: module.displayName,
            })),
        [data?.modules]
    );

    return (
        <FormFields.SelectField
            {...props}
            filterOption={filterOption}
            loading={!data?.modules && loading}
            optionFilterProp="label"
            options={options}
            showSearch
        />
    );
};

export default UserModuleSelectField;
